import VueRouter from 'vue-router';
import FragranceFinder from 'components/storefront/fragrance-finder';

function createRouter() {
  return new VueRouter({
    routes: [
      {
        path: '*',
        component: FragranceFinder,
        props: {
          searchIndexNames: [
            {
              displayName: 'Alphabetical',
              algoliaName: `Cs_Fragrance_${csConf.railsEnv}`,
              isDefault: true
            },
            {
              displayName: 'Newest',
              algoliaName: `Cs_Fragrance_by_newest_${csConf.railsEnv}`
            },
            {
              displayName: 'Price: Low to High',
              algoliaName: `Cs_Fragrance_by_price_${csConf.railsEnv}`
            },
            {
              displayName: 'Highest Rated',
              algoliaName: `Cs_Fragrance_by_reviews_${csConf.railsEnv}`
            }
          ]
        }
      }
    ]
  });
}

export default createRouter;
